(function() {
  'use strict';

  let is_collection_page = document.querySelector('#MainContent').classList.contains('theme-template-collection')
  if(is_collection_page) {
      let isInitialized = false;
      const SPECIAL_COLLECTION_ID = '653357482326';
      var variant_id;
      
      // Initialize the popup system
      function initSpecialCollectionPopup() {
        if (isInitialized) return;
        
        const popup = document.getElementById('special-collection-popup');
        const confirmCheckbox = document.getElementById('confirm-special-purchase');
        const proceedBtn = document.getElementById('proceed-special-purchase');
        const cancelBtn = document.getElementById('cancel-special-purchase');
        const specialButtons = document.querySelectorAll('.special-collection-btn');
        const regularButtons = document.querySelectorAll('.regular-add-to-cart');
        
        if (!popup) {
          console.log('Special collection popup not found - likely not a special collection');
          initRegularAddToCart();
          return;
        }
        
        console.log('Initializing special collection popup system');
        
        // Handle checkbox state
        if (confirmCheckbox && proceedBtn) {
          confirmCheckbox.addEventListener('change', function() {
            const isChecked = this.checked;
            proceedBtn.disabled = !isChecked;
            proceedBtn.style.backgroundColor = isChecked ? '#667eea' : '#ccc';
            proceedBtn.style.cursor = isChecked ? 'pointer' : 'not-allowed';
          });
        }
        
        // Handle special collection button clicks
        specialButtons.forEach(button => {
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            variant_id = button.getAttribute('data-variant-id')
            showSpecialPopup();
          });
        });
        
        // Handle proceed button
        if (proceedBtn) {
          proceedBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (confirmCheckbox && confirmCheckbox.checked) {
              proceedWithSpecialPurchase();
            }
          });
        }
        
        // Handle cancel button
        if (cancelBtn) {
          cancelBtn.addEventListener('click', function(e) {
            e.preventDefault();
            closeSpecialPopup();
          });
        }
        
        // Close popup when clicking outside
        popup.addEventListener('click', function(e) {
          if (e.target === popup) {
            closeSpecialPopup();
          }
        });
        
        // Close popup on escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && popup.style.display === 'flex') {
            closeSpecialPopup();
          }
        });
        
        isInitialized = true;
        console.log('Special collection popup initialized successfully');
      }
      
      // Initialize regular add to cart for non-special collections
      function initRegularAddToCart() {
        const regularButtons = document.querySelectorAll('.regular-add-to-cart');
        
        regularButtons.forEach(button => {
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            addToCartRegular(this);
          });
        });
        
        console.log('Regular add to cart initialized');
      }
      
      // Show special popup
      function showSpecialPopup() {
        const popup = document.getElementById('special-collection-popup');
        const confirmCheckbox = document.getElementById('confirm-special-purchase');
        const proceedBtn = document.getElementById('proceed-special-purchase');
        
        if (popup) {
          popup.style.display = 'flex';
          document.body.style.overflow = 'hidden';
          
          // Reset form state
          if (confirmCheckbox) {
            confirmCheckbox.checked = false;
          }
          if (proceedBtn) {
            proceedBtn.disabled = true;
            proceedBtn.style.backgroundColor = '#ccc';
            proceedBtn.style.cursor = 'not-allowed';
          }
          
          console.log('Special popup displayed');
        }
      }
      
      // Close special popup
      function closeSpecialPopup() {
        const popup = document.getElementById('special-collection-popup');
        
        if (popup) {
          popup.style.display = 'none';
          document.body.style.overflow = '';
          console.log('Special popup closed');
        }
      }
      
      // Proceed with special purchase
      async function proceedWithSpecialPurchase() {
        const proceedBtn = document.getElementById('proceed-special-purchase');
        const btnText = proceedBtn.querySelector('.btn-text');
        const btnLoading = proceedBtn.querySelector('.btn-loading');
        
        // Show loading state
        setLoadingState(proceedBtn, true);
        if (btnText) btnText.style.display = 'none';
        if (btnLoading) btnLoading.style.display = 'inline';
        
        try {
            // const variantId = getVariantId();
          
            // if (!variantId) {
            //      throw new Error('Product variant ID not found');
            // }
          if (!variant_id) {
            throw new Error('Product variant ID not found');
          }
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
            //   id: variantId,
              id: variant_id,
              quantity: 1,
              properties: {
                '_special_collection': SPECIAL_COLLECTION_ID,
                '_confirmed_purchase': 'true'
              }
            })
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const data = await response.json();
          console.log('Special item added to cart:', data);
          
          // Store flag to open cart after refresh
          sessionStorage.setItem('shouldOpenCart', 'true');
          closeSpecialPopup();
          
          // Refresh the page
            //   window.location.href = window.location.href;
            openCartDrawer()

          
        } catch (error) {
          console.error('Error adding special item to cart:', error);
          // alert('Error adding item to cart. Please try again.');
        } finally {
          // Reset loading state
          setLoadingState(proceedBtn, false);
          if (btnText) btnText.style.display = 'inline';
          if (btnLoading) btnLoading.style.display = 'none';
        }
      }
      
      // Regular add to cart function
      async function addToCartRegular(button) {
        const variantId = button.dataset.variantId;
        
        if (!variantId) {
          console.error('Variant ID not found for regular add to cart');
          return;
        }
        
        setLoadingState(button, true);
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const data = await response.json();
          console.log('Regular item added to cart:', data);
          
          // Store flag to open cart after refresh
          sessionStorage.setItem('shouldOpenCart', 'true');
          
          // Refresh the page
          window.location.href = window.location.href;
          
        } catch (error) {
          console.error('Error adding regular item to cart:', error);
          alert('Error adding item to cart. Please try again.');
        } finally {
          setLoadingState(button, false);
        }
      }
      
      // Get variant ID from button data
      function getVariantId() {
        const specialButton = document.querySelector('.special-collection-btn[data-variant-id]');
        console.log(specialButton);
        return specialButton ? specialButton.dataset.variantId : null;
      }
      
      // Set loading state for buttons
      function setLoadingState(button, isLoading) {
        if (isLoading) {
          button.disabled = true;
          button.style.opacity = '0.7';
          button.style.cursor = 'not-allowed';
          const spinner = button.querySelector('.loading-spinner');
          if (spinner) spinner.style.display = 'block';
        } else {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          const spinner = button.querySelector('.loading-spinner');
          if (spinner) spinner.style.display = 'none';
        }
      }
      
      // Open cart drawer
      function openCartDrawer() {
        console.log('Attempting to open cart drawer...');
        
        // Method 1: Alpine.js store
        if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
            fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                Alpine.store('xMiniCart').items = cart.items;
                Alpine.store('xMiniCart').count = cart.item_count;
                Alpine.store('xMiniCart').reLoad();
                setTimeout(() => {
                    Alpine.store('xMiniCart').openCart();
                }, 500)
            });
          console.log('Opened cart via Alpine store');
          return;
        }

        // Method 2: Common cart trigger selectors
        const cartTriggers = [
          '[data-cart-drawer-trigger]',
          '.cart-drawer-trigger',
          '#cart-icon-bubble',
          '.cart-icon',
          '[data-cart-toggle]',
          '.header-cart-toggle',
          '#cart-drawer-toggle'
        ];
        
        for (let selector of cartTriggers) {
          const trigger = document.querySelector(selector);
          if (trigger) {
            trigger.click();
            console.log('Opened cart by clicking trigger:', selector);
            return;
          }
        }
        
        // Method 3: Show cart drawer directly
        const cartDrawers = [
          '#cart-drawer',
          '.cart-drawer',
          '#mini-cart',
          '.mini-cart',
          '#cart-sidebar'
        ];
        
        for (let selector of cartDrawers) {
          const drawer = document.querySelector(selector);
          if (drawer) {
            drawer.style.display = 'block';
            drawer.classList.add('open', 'active', 'show');
            console.log('Opened cart drawer directly:', selector);
            return;
          }
        }
        
        console.log('Could not find cart drawer to open');
      }
      
      // Check if we should open cart after page load
      function checkForCartOpening() {
        if (sessionStorage.getItem('shouldOpenCart') === 'true') {
          sessionStorage.removeItem('shouldOpenCart');
          setTimeout(() => {
            openCartDrawer();
          }, 500); // Slight delay to ensure page is fully loaded
        }
      }
      
      // Initialize when DOM is ready
      function initialize() {
        // Add styles only once
        if (!document.getElementById('special-collection-styles')) {
          const style = document.createElement('style');
          style.id = 'special-collection-styles';
          style.textContent = `
            @keyframes slideIn {
              from {
                transform: translateX(100%);
                opacity: 0;
              }
              to {
                transform: translateX(0);
                opacity: 1;
              }
            }
            
            .special-popup {
              backdrop-filter: blur(4px);
            }
            
            .popup-content {
              animation: popupSlide 0.3s ease-out;
            }
            
            @keyframes popupSlide {
              from {
                transform: scale(0.9);
                opacity: 0;
              }
              to {
                transform: scale(1);
                opacity: 1;
              }
            }
          `;
          document.head.appendChild(style);
        }
        
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
            initSpecialCollectionPopup();
            // checkForCartOpening();
          });
        } else {
          initSpecialCollectionPopup();
        //   checkForCartOpening();
        }
        
        // Fallback initialization
        window.addEventListener('load', function() {
          setTimeout(() => {
            if (!isInitialized) {
              initSpecialCollectionPopup();
            }
            // checkForCartOpening();
          }, 100);
        });
      }
      
      // Start initialization
      initialize();
  }
  
})();

